import { forwardRef, useCallback } from 'react';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconFilledProps, IconRender } from '../types.ts';

const Person = forwardRef<SVGSVGElement | null, IconFilledProps>(function Person({ filled, dataTestId, ...props }, ref) {
  // eslint-disable-next-line no-restricted-syntax
  const iconRender = useCallback<IconRender>(
    (color: string) => (
      <>
        {/* default */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 10.5C13.3807 10.5 14.5 9.38071 14.5 8C14.5 6.61929 13.3807 5.5 12 5.5C10.6193 5.5 9.5 6.61929 9.5 8C9.5 9.38071 10.6193 10.5 12 10.5ZM12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z'
          fill={filled ? 'transparent' : color}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.04212 15.7065C8.7579 12.0656 15.2421 12.0656 19.9579 15.7065C20.2992 15.97 20.5 16.3835 20.5 16.8226V18.75C20.5 19.3023 20.0523 19.75 19.5 19.75H4.5C3.94772 19.75 3.5 19.3023 3.5 18.75V16.8226C3.5 16.3835 3.70085 15.97 4.04212 15.7065ZM4.95714 16.8752V18.25H19.0429V16.8752C14.8622 13.6761 9.13778 13.6761 4.95714 16.8752Z'
          fill={filled ? 'transparent' : color}
        />
        {/* filled */}
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M12 12C14.2091 12 16 10.2091 16 8C16 5.79086 14.2091 4 12 4C9.79086 4 8 5.79086 8 8C8 10.2091 9.79086 12 12 12Z'
          fill={filled ? color : 'transparent'}
        />
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M4.04212 15.7065C8.7579 12.0656 15.2421 12.0656 19.9579 15.7065C20.2992 15.97 20.5 16.3835 20.5 16.8226V18.75C20.5 19.3023 20.0523 19.75 19.5 19.75H4.5C3.94772 19.75 3.5 19.3023 3.5 18.75V16.8226C3.5 16.3835 3.70085 15.97 4.04212 15.7065Z'
          fill={filled ? color : 'transparent'}
        />
      </>
    ),
    [filled],
  );
  return <BaseComponent ref={ref} dataTestId={dataTestId ?? 'person-icon-svg'} iconRender={iconRender} {...props} />;
});

export default Person;
